module.exports = __webpack_public_path__ + "img/dll.74186a70.svg";